<template>
    <button class="migrol-form__info-button" :class="extraCssClass">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 20" style="width:20px;height:auto;display:inline-block">
            <defs>
                <path id="prefix__a" d="M0 0h5v12.5H0z" />
            </defs>
            <g fill="none" fill-rule="evenodd">
                <circle cx="10" cy="10" r="10" fill="#E6E6E6" fill-rule="nonzero" />
                <g transform="translate(7.5 4)">
                    <mask id="prefix__b" fill="#fff">
                        <use xlink:href="#prefix__a" />
                    </mask>
                    <path fill="#1D1D1B" d="M1.2.5c-.4.4-.6.8-.6 1.3 0 .4.2.9.6 1.2.3.3.8.5 1.3.5s1-.2 1.3-.5c.4-.3.6-.8.6-1.2 0-.5-.2-1-.6-1.3C3.5.2 3 0 2.5 0s-1 .2-1.3.5zM1 10.4V6.8H.5l-.3-.1a.5.5 0 01-.2-.4V5.2c0-.2 0-.3.2-.4l.3-.1h3l.3.1.2.4v5.2h.5l.3.1.2.3V12c0 .1 0 .3-.2.4l-.3.1h-4l-.3-.1A.5.5 0 010 12v-1.2s0-.2.2-.3l.3-.1H1z" mask="url(#prefix__b)" />
                </g>
            </g>
        </svg>
        <div :class="computedClass">
            <slot />
        </div>
    </button>
</template>

<script>
    export default {
        props: {
            position: {
                type: String,
                required: false,
                default: 'top'
            },
            extraCssClass: {
                type: String,
                required: false,
                default: ''
            }
        },
        computed: {
            computedClass() {
                return `migrol-form__info-button-tooltip migrol-form__info-button-tooltip--${this.position}`;
            }
        }
    };
</script>